// extracted by mini-css-extract-plugin
export var acitonButtons = "_fp-0";
export var additionalIcon = "_fp-f";
export var block = "_fp-1";
export var blockContent = "_fp-7";
export var blockDescription = "_fp-8";
export var blockIcon = "_fp-9";
export var blockTitle = "_fp-6";
export var border = "_fp-a";
export var center = "_fp-l";
export var edge = "_fp-b";
export var edgeLabel = "_fp-c";
export var edgePath = "_fp-d";
export var error = "_fp-e";
export var flowchart = "_fp-g";
export var flowchartContent = "_fp-h";
export var highlighted = "_fp-3";
export var hover = "_fp-4";
export var icon = "_fp-i";
export var left = "_fp-m";
export var navButton = "_fp-j";
export var navButtons = "_fp-k";
export var right = "_fp-n";
export var selected = "_fp-2";
export var small = "_fp-5";